var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadFileAsArrayBuffer, PackedGaussians } from './ply';
import { CameraFileParser, InteractiveCamera } from './camera';
import { Renderer } from './renderer';
if (!navigator.gpu) {
    alert("WebGPU not supported on this browser! (navigator.gpu is null)");
}
// grab the DOM elements
const canvas = document.getElementById("canvas-webgpu");
const loadingPopup = document.getElementById('loading-popup');
const fpsCounter = document.getElementById('fps-counter');
const cameraFileInput = document.getElementById('cameraButton');
const cameraList = document.getElementById('cameraList');
const plyFileInput = document.getElementById('plyButton');
// create the camera and renderer globals
let interactiveCamera = InteractiveCamera.default(canvas);
var currentRenderer;
// swap the renderer when the ply file changes
function handlePlyChange(event) {
    const file = event.target.files[0];
    function onFileLoad(arrayBuffer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (currentRenderer) {
                yield currentRenderer.destroy();
            }
            const gaussians = new PackedGaussians(arrayBuffer);
            try {
                const context = yield Renderer.requestContext(gaussians);
                const renderer = new Renderer(canvas, interactiveCamera, gaussians, context, fpsCounter);
                currentRenderer = renderer; // bind to the global scope
                loadingPopup.style.display = 'none'; // hide loading popup
            }
            catch (error) {
                loadingPopup.style.display = 'none'; // hide loading popup
                alert(error);
            }
        });
    }
    if (file) {
        loadingPopup.style.display = 'block'; // show loading popup
        loadFileAsArrayBuffer(file)
            .then(onFileLoad);
    }
}
// loads the default ply file (bundled with the source) at startup, useful for dev
function loadDefaultPly() {
    return __awaiter(this, void 0, void 0, function* () {
        const url = "pc_short.ply";
        loadingPopup.style.display = 'block'; // show loading popup
        const content = yield fetch(url);
        const arrayBuffer = yield content.arrayBuffer();
        const gaussians = new PackedGaussians(arrayBuffer);
        const context = yield Renderer.requestContext(gaussians);
        const renderer = new Renderer(canvas, interactiveCamera, gaussians, context, fpsCounter);
        currentRenderer = renderer; // bind to the global scope
        loadingPopup.style.display = 'none'; // hide loading popup
    });
}
// DEV: uncomment this line to load the default ply file at startup
//loadDefaultPly();
// add event listeners
plyFileInput.addEventListener('change', handlePlyChange);
new CameraFileParser(cameraFileInput, cameraList, canvas, (camera) => interactiveCamera.setNewCamera(camera));
